// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uHJ7","col":"styles_col__VdLTb"};